import React from "react";
import { LogoStyled, LGLogoStyled } from "./styles/Styled";

const logos = ["2x.png", "3x.png", "4x.png"];
const resolutions = [1920, 4096, 8192];
const lgLogo = 'https://starzplay-img-prod-ssl.akamaized.net/prd-peg-data/default/bigscreen/images/lg/lg-promotion/logo-lg-promotion.png';

export default ({ width, height }) => {
  let renderLogo =
    window.innerWidth <= resolutions[0]
      ? logos[0]
      : resolutions[0] <= window.innerWidth <= resolutions[1]
      ? logos[1]
      : resolutions[1] >= window.innerWidth
      ? logos[2]
      : logos[1];

  return <LogoStyled src={`/images/${renderLogo}`} alt="Logo" width={width} height={height} />;
};

export const LGLogo = ({width, height}) => {
  return <LGLogoStyled src={`${lgLogo}`} alt="LGLogo" width={width} height={height} />;
}
